import axios from 'axios';

export function login(context, payload) {
  return new Promise((resolve, reject) => {
    axios.post('/auth/acceso', payload.form).then((resp) => {
      console.log('action login', resp);
      if (resp && !resp.error) {
        context.commit('login', resp.data);
        resolve(resp);
      } else {
        reject(new Error("Invalid login data"));
      }
    }).catch((err) => {
      reject(err);
    });
  });
}

export function logout(context, payload) {
  context.commit('logout');
}

export function isLoggedIn(context, payload) {
  return context.state.loggedIn;
}



// WEBPACK FOOTER //
// ./src/modules/login/login.actions.js